import ScreenReaderAnnouncerContainer from './container';

export default ScreenReaderAnnouncerContainer;
